<!-- 检测服务范围 -->
<template>
  <div class="testServe">
    <h3 class="h3">{{testServe[0].title}}</h3>
    <div class="testContent width">
      <div class="testItem" v-for="(item,i) in testServe[0].child" :key="i">
        <div v-if="item.id%2!=0">
          <div class="textCon" @mouseover="show_hide(item.id)" @mouseleave="show=false">
            <div class="textConTitle">{{item.title}}</div>
            <div class="textConP">{{item.content}}</div>
            <i class="el-icon-caret-bottom"></i>
            <div class="textLoan" v-show="indexShow==item.id?show:''">
              <div class="textConTitle">{{item.title}}</div>
              <div class="textConP">{{item.content}}</div>
              <i class="el-icon-caret-bottom"></i>
            </div>
          </div>
          <div class="imgCon">
            <img :src="item.imgUrl" alt srcset />
          </div>
        </div>
        <div v-if="item.id%2==0">
          <div class="imgCon">
            <img :src="item.imgUrl" alt srcset />
          </div>
          <div class="textCon" @mouseover="show_hide(item.id)" @mouseleave="show=false">
            <div class="textConTitle">{{item.title}}</div>
            <div class="textConP">{{item.content}}</div>
            <i class="el-icon-caret-top"></i>
            <div class="textLoan" v-show="indexShow==item.id?show:''">
              <div class="textConTitle">{{item.title}}</div>
              <div class="textConP">{{item.content}}</div>
              <i class="el-icon-caret-top"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  components: {},
  props: { testServe: Array },
  data() {
    return {
      show: false,
      indexShow: '',
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    show_hide(i) {
      this.show = true
      this.indexShow = i
    },
  },
}
</script>
<style lang="less" scoped>
.testServe {
  width: 100%;
  padding-bottom: 40px;
  margin-bottom: 10px;
  padding-top: 20px;
  margin-top: 10px;
  background: url('../assets/images/u1171.png') 100% 100% no-repeat;
  background-size: cover;
  .h3 {
    width: 140px;
    height: 25px;
    font-weight: 700;
    font-style: normal;
    font-size: 20px;
    text-align: center;
    padding-bottom: 10px;
    border-bottom: 2px solid #0078d7;
    margin: 0 auto 20px auto;
  }
  .testContent {
    display: flex;
    .testItem {
      flex: 1;
      .textCon {
        position: relative;
        background-color: #fff;
        height: 240px;
        .textConTitle {
          text-align: center;
          line-height: 62px;
          font-size: 18px;
          margin-bottom: 20px;
        }
        .textConP {
          padding: 0 10px;
          line-height: 18px;
        }
        .el-icon-caret-bottom {
          position: absolute;
          font-size: 60px;
          left: 50%;
          margin-left: -30px;
          bottom: -38px;
          color: #fff;
        }
        .el-icon-caret-top {
          position: absolute;
          font-size: 60px;
          left: 50%;
          margin-left: -30px;
          top: -38px;
          color: #fff;
        }
        .textLoan {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          color: #fff;
          background-color: #0078d7;
          .textConTitle {
            color: #fff;
          }
          .textConP {
            color: #fff;
          }
          .el-icon-caret-bottom {
            color: #0078d7;
          }
          .el-icon-caret-top {
            color: #0078d7;
          }
        }
      }
      .imgCon {
        img {
          display: block;
          width: 100%;
          height: 240px;
        }
      }
    }
  }
}
</style>
